// Comprehensive polyfill for axios and global objects
;(function () {
  // First, ensure globalThis is available
  if (typeof globalThis === 'undefined') {
    if (typeof self !== 'undefined') {
      // @ts-ignore
      self.globalThis = self
    } else if (typeof window !== 'undefined') {
      // @ts-ignore
      window.globalThis = window
    } else if (typeof global !== 'undefined') {
      // @ts-ignore
      global.globalThis = global
    }
  }

  // Ensure global is defined and properly set
  if (typeof window !== 'undefined') {
    // @ts-ignore
    window.global = window
    // @ts-ignore
    if (!window.global.Request) {
      // @ts-ignore
      window.global.Request = window.Request
    }
    // @ts-ignore
    if (!window.global.Response) {
      // @ts-ignore
      window.global.Response = window.Response
    }
    // @ts-ignore
    if (!window.global.ReadableStream) {
      // @ts-ignore
      window.global.ReadableStream = window.ReadableStream
    }
    // @ts-ignore
    if (!window.global.TextEncoder) {
      // @ts-ignore
      window.global.TextEncoder = window.TextEncoder
    }
  }
})()
